import { Tag } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { FormattedNumber } from "react-intl";
import { CheckCircleFilled, CloseCircleFilled, ExclamationCircleFilled, PercentageOutlined } from "@ant-design/icons";
import { get as getDataWithLodash } from "lodash";
import "./AgTable.scss";
import CorporateFareRoundedIcon from "@mui/icons-material/CorporateFareRounded";
import FlightTakeoffRoundedIcon from "@mui/icons-material/FlightTakeoffRounded";
import Typography from "../Typography";
import airlineLogos from "./HelperTools/IconMaps";
import { STATE_GSTIN_ICON } from "./HelperTools/stateIconMap";
import { STATE_NAME_CODE } from "global.constants";
import ToolParamInvoker from "./HelperTools/ToolParamInvoker";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import PublicIcon from "@mui/icons-material/Public";
import IndianFlag from "static/images/indianflag.png";
import CompanyLogo from "./CompanyLogo";
import { COUNTRY_ISO_MAP, currencySymbolMap } from "app/scenes/VAT/vat.globa.constant";
function formatFileSize(bytes: any) {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
}




export const handleAgCellDataFormat = (
  formatType: string,
  formatData: any,
  formatProps: any,
  fullParamData: any,
  showCount: boolean
) => {
  switch (formatType) {
    case "CHIP":
      return <Tag color={formatProps?.chipColor}>{formatData}</Tag>;
    case "CHIP_SHORT_TEXT":
      return (
        <Tag color={formatProps?.chipColor}>
          {formatData?.toString().slice(0, 8)}
        </Tag>
      );
    case "RATE":
      return (
        <div style={{ width: "100%", textAlign: "right" }}>
          {formatData ? formatData.toString() + "%" : ""}
        </div>
      );
    case "ENTITY":
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <CorporateFareRoundedIcon style={{ fontSize: 19, marginRight: 4 }} />
          {formatData}
        </div>
      );

      case "ENTITY_WITH_LOGO":
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <CompanyLogo companyName={formatData} />
  
            {formatData}
          </div>
        );
    case "COUNTRY":
          return (
            <div style={{display:"flex",alignItems:"center",gap:8}} ><img style={{width:20,height:20}} src={COUNTRY_ISO_MAP[formatData]?`https://flagcdn.com/${COUNTRY_ISO_MAP[formatData]}.svg`:"https://upload.wikimedia.org/wikipedia/commons/2/2e/Unknown_flag_-_European_version.png"} alt="flag" /><Typography>{formatData}</Typography></div>
          );
   case "CURRENCY":
            return (
              <div style={{display:"flex",alignItems:"center",gap:8}} >
                <Tag>{currencySymbolMap[formatData]} {formatData}</Tag>
                </div>
            );
    case "AIRLINE":
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={airlineLogos[formatData] || airlineLogos["NA"]}
            alt="airlineLogo"
            style={{
              width: 30,
              height: 30,
              marginRight: 4,
              objectFit: "contain",
            }}
          />

          {formatData}
        </div>
      );
    case "PARTNERSHIP":
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={formatProps?.partner_logo}
            alt="airlineLogo"
            style={{
              height: 18,
              objectFit: "cover",
              marginRight: 6,
            }}
          />

          {formatData}
        </div>
      );
    case "PERSON":
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <GroupRoundedIcon style={{ fontSize: 19, marginRight: 4 }} />
          {(formatData || "").toUpperCase()}
        </div>
      );

    case "AMOUNT":
      let amountData =
        typeof formatData === "string"
          ? parseFloat(formatData.replace(/,/g, ""))
          : formatData;
      return (
        <div
          style={{
            textAlign: "right",
            width: "100%",
            color: amountData < 0 ? "#dd5061" : "",
            fontWeight: amountData < 0 ? 700 : 400,
          }}
        >
          {amountData === undefined ? null : (
            <FormattedNumber
              value={amountData || 0}
              style="currency"
              currency={"INR"}
              minimumFractionDigits={0}
              maximumFractionDigits={0}
            />
          )}
        </div>
      );

    case "AMOUNT_BOLD":
      let newAmountData =
        typeof formatData === "string"
          ? parseFloat(formatData.replace(/,/g, ""))
          : formatData;
      return (
        <div
          style={{
            textAlign: "right",
            width: "100%",
            color: newAmountData < 0 ? "#dd5061" : "",
            fontWeight: 700,
          }}
        >
          {newAmountData === undefined ? null : (
            <FormattedNumber
              value={newAmountData || 0}
              style="currency"
              currency="INR"
            />
          )}
        </div>
      );
    case "GSTIN_STATE":
      let newFormatData =
        formatData?.length > 2 ? formatData?.substring(0, 2) : formatData;
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          {formatData ? (
            <img
              src={STATE_GSTIN_ICON[newFormatData] || STATE_GSTIN_ICON["NA"]}
              style={{
                width: 24,
                height: 24,
                marginRight: 4,
                objectFit: "contain",
              }}
              alt="stateIcon"
            />
          ) : null}
          {STATE_NAME_CODE[newFormatData] || ""}
        </div>
      );
    case "FILE_SIZE":
      return formatData ? formatFileSize(formatData) : "0 B";

    case "DATE":
    case "DATE":
      // Check for invalid date cases
      if (
        !formatData ||
        formatData === "0" ||
        formatData === 0 ||
        formatData === "" ||
        formatData === null ||
        formatData === undefined
      ) {
        return "-"; // Display "-" for invalid dates
      }

      const formattedDate = moment(formatData).format(
        formatProps?.dateFormat || "DD-MM-YYYY"
      );

      return formattedDate === "Invalid date" ? "-" : formattedDate;
    case "TAGS":
      let tags: any = [];
      (formatData || []).forEach((element: any) => {
        tags.push(
          <Tag
            // onClick={() => applyFilter(fieldKey, element)}
            color={formatProps?.chipColor}
            id="filterTag"
          >
            {element}
          </Tag>
        );
      });
      return tags;
    case "404":
      return formatData ? (
        formatData
      ) : (
        <div
          style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            color: "#dd5061",
            fontWeight: 700,
          }}
        >
          Missing
        </div>
      );
    case "ROUTE":
      return (
        <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
          {formatProps[formatData] === "INDIA" ? (
            <img
              src={IndianFlag}
              alt="Icon"
              style={{ fontSize: 18, width: 26, height: 26, marginRight: 4 }}
            />
          ) : (
            <PublicIcon style={{ fontSize: 20, marginRight: 4 }} />
          )}
          {formatData}
        </div>
      );
      case "MATCH":
        return (
          <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
            <Tag
              color={
                formatProps?.[formatData] === "MATCH"
                  ? "green"
                  : formatProps?.[formatData] === "PARTIAL_MATCH"
                  ? "gold"
                  : "red"
              }
              style={{
                alignItems: "center",
                display: "flex",
                width: "fit-content",
              }}
            >
              {formatProps?.[formatData] === "MATCH" ? (
                <CheckCircleFilled style={{ color: "#43a522", marginRight: 6 }} />
              ) : formatProps?.[formatData] === "PARTIAL_MATCH" ? (
                <ExclamationCircleFilled style={{ color: "#e0a800", marginRight: 6 }} />
              ) : (
                <CloseCircleFilled style={{ color: "#dd5061", marginRight: 6 }} />
              )}
      
              <span />
              {formatData || formatProps?.defaultText || "-"}
            </Tag>
          </div>
        );

    case "ZA_BOOLEAN_SIGN":
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
         formatData ==="√"?<CheckCircleFilled style={{ color: "#27ae60", marginRight: 6 }} />:formatData==="%"?<PercentageOutlined style={{color:"#27ae60"}} />:<CloseCircleFilled style={{ color: "#e74c3c", marginRight: 6 }} />
        </div>
      );  
      
    case "MATCH_COMPARE":
      let isMatched = true;
      (formatProps?.compareObjects || []).forEach((objectPath: string) => {
        if (formatData !== getDataWithLodash(fullParamData, objectPath, "-")) {
          isMatched = false;
          return;
        }
      });

      return (
        <div
          style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          {isMatched ? (
            <CheckCircleFilled style={{ color: "#43a522", marginRight: 6 }} />
          ) : (
            <CloseCircleFilled style={{ color: "#dd5061", marginRight: 6 }} />
          )}

          <span />
          {formatData || formatProps?.defaultText || "-"}
        </div>
      );
    case "MATCH_PRESENCE":
      let foundData = false;
      (formatProps?.compareObjects || []).forEach((objectPath: string) => {
        let checkResult = getDataWithLodash(fullParamData, objectPath, "NA");
        if (checkResult && checkResult !== "NA") {
          foundData = true;
          return;
        }
      });

      return (
        <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
          <Tag
            color={foundData ? "green" : "red"}
            style={{
              alignItems: "center",
              display: "flex",
              width: "fit-content",
            }}
          >
            {foundData ? (
              <CheckCircleFilled style={{ color: "#43a522", marginRight: 6 }} />
            ) : (
              <CloseCircleFilled style={{ color: "#dd5061", marginRight: 6 }} />
            )}

            <span />
            {foundData ? "Available" : "Missing"}
          </Tag>
        </div>
      );

    case "MATCH_PRESENCE2":
      let foundNewData = false;
      (formatProps?.compareObjects || []).forEach((objectPath: string) => {
        let checkResult = getDataWithLodash(fullParamData, objectPath, "NA");
        if (checkResult && checkResult !== "NA") {
          foundNewData = true;
          return;
        }
      });

      return (
        <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
          <Tag
            color={foundNewData ? "green" : "red"}
            style={{
              alignItems: "center",
              display: "flex",
              width: "fit-content",
            }}
          >
            {foundNewData ? (
              <CheckCircleFilled style={{ color: "#43a522", marginRight: 6 }} />
            ) : (
              <CloseCircleFilled style={{ color: "#dd5061", marginRight: 6 }} />
            )}

            <span />
            {foundNewData ? "Invoice Received" : "Invoice Not Received"}
          </Tag>
        </div>
      );

    case "MATCH_COMPARE_TEXT":
      let isTextMatched = true;
      (formatProps?.compareObjects || []).forEach((objectPath: string) => {
        if (formatData !== getDataWithLodash(fullParamData, objectPath, "-")) {
          isTextMatched = false;
          return;
        }
      });

      return (
        <div
          style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            color: isTextMatched ? "" : "#dd5061",
            fontWeight: isTextMatched ? 400 : 700,
          }}
        >
          {formatData || formatProps?.defaultText || "-"}
        </div>
      );
    case "NUMBER":
      return (
        <div
          style={{
            textAlign: "right",
            width: "100%",
            color: formatData < 0 ? "#dd5061" : "",
            fontWeight: formatData < 0 ? 700 : 400,
          }}
        >
          <FormattedNumber
            value={formatData || 0}
            minimumFractionDigits={0}
            maximumFractionDigits={0}
          />
        </div>
      );

    default:
      return formatData;
  }
};

const handleValueGetter = (params: any, dataKey: string, defaultValue: any) => {
  let value;
  if (params.colDef.formatType === "CUSTOM_RENDER") {
    value = params?.colDef?.formatProps?.valueGetterData
      ? params?.colDef?.formatProps?.valueGetterData(params.data, params)
      : getDataWithLodash(params?.data, dataKey, "NA");
  } else if (params.colDef.formatType === "DATE") {
    // return new Date(getDataWithLodash(params?.data, dataKey, "NA"));
    // return getDataWithLodash(params?.data, dataKey, "NA")
    value = moment(getDataWithLodash(params?.data, dataKey, "NA")).format(
      params?.colDef?.formatProps?.dateFormat || "DD-MM-YYYY"
    );
  } else {
    value = getDataWithLodash(params?.data, dataKey, "NA");
  }
  
  // Convert objects to JSON strings to prevent React rendering errors
  if (value !== null && typeof value === 'object' && !Array.isArray(value) && !(value instanceof Date)) {
    return JSON.stringify(value);
  }
  
  return value;
};

export const handleCellRenderer = () => {
  return {
    valueGetter: (params: any) => {
      let value;
      if (params.colDef.colId && params.colDef.colId === "ag-Grid-AutoColumn") {
        // If the "no"de is a group, return the group key
        value = params.value;
      } else if (params.colDef.column && params.column.aggregationActive) {
        // If the node is a group, return the group key
        value = params.value;
      } else if (params.node.group) {
        value = params.data?.[params.colDef.field] ?? params.value;
      } else {
        // If the node is a leaf node, return the individual value
        value = handleValueGetter(params, params?.colDef?.field, "NA");
      }
      
      // Convert objects to JSON strings to prevent React rendering errors
      if (value !== null && typeof value === 'object' && !Array.isArray(value) && !(value instanceof Date)) {
        return JSON.stringify(value);
      }
      
      return value;
    },
    cellRenderer: (params: any) => {
      // Helper to ensure value is not an object
      const ensureStringValue = (value: any) => {
        if (value !== null && typeof value === 'object' && !Array.isArray(value) && !(value instanceof Date)) {
          return JSON.stringify(value);
        }
        return value;
      };

      return params.colDef.formatType === "INVOICE" ? (
        <ToolParamInvoker {...params} />
      ) : params.colDef.colId &&
        params.colDef.colId === "ag-Grid-AutoColumn" ? (
        handleAgCellDataFormat(
          params?.colDef?.formatType,
          ensureStringValue(params?.value),
          params?.colDef?.formatProps,
          params?.data,
          true
        )
      ) : (params.colDef.colId && params.colDef.colId.includes("pivot")) ||
        params.colDef.enableValue ? (
        handleAgCellDataFormat(
          params?.colDef?.formatType,
          ensureStringValue(params?.value),
          params?.colDef?.formatProps,
          params?.data,
          false
        )
      ) : params.node.group ? (
        "-"
      ) : (
        (() => {
          // Get the value and ensure objects are converted to strings
          let cellValue = getDataWithLodash(params?.data, params?.colDef?.field, "-");
          // If it's an object, convert to JSON string
          cellValue = ensureStringValue(cellValue);
          return handleAgCellDataFormat(
            params?.colDef?.formatType,
            cellValue,
            params?.colDef?.formatProps,
            params?.data,
            false
          );
        })()
      );
    },
  };
};
